import { Facebook, Instagram, Mail } from "lucide-react";
import { SITE } from "@/data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/5 pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-3">
              <span className="block w-9 h-9 border border-[#D4AF37] rotate-45 relative">
                <span className="absolute inset-1 bg-[#D4AF37]/10" />
              </span>
              <span className="font-display text-white text-lg tracking-wide">
                Cutting <span className="gold-text">Edge</span> Detail
              </span>
            </div>
            <p className="text-white/45 text-sm mt-5 max-w-md leading-relaxed">
              Family-owned and detail-obsessed. Bringing factory-fresh finish
              and meaningful protection to vehicles across Pukekohe and greater
              Auckland.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">
              Studio
            </p>
            <p className="text-white/70 text-sm leading-relaxed">
              {SITE.address}
            </p>
            <a
              href={`tel:${SITE.phoneRaw}`}
              className="block text-white/70 hover:text-[#D4AF37] text-sm mt-3 link-gold w-fit"
            >
              {SITE.phone}
            </a>
            <a
              href={`mailto:${SITE.email}`}
              className="block text-white/70 hover:text-[#D4AF37] text-sm mt-1 link-gold w-fit break-all"
            >
              {SITE.email}
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">
              Follow
            </p>
            <div className="flex items-center gap-3">
              <a
                href={SITE.socials.facebook}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
                data-testid="footer-facebook"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href={SITE.socials.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href={`mailto:${SITE.email}`}
                aria-label="Email"
                data-testid="footer-email"
                className="w-10 h-10 border border-white/10 flex items-center justify-center text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition"
              >
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-white/35 text-xs">
            © {new Date().getFullYear()} Cutting Edge Detail. All rights
            reserved.
          </p>
          <p className="text-white/30 text-[11px] uppercase tracking-[0.3em]">
            Crafted for the obsessed
          </p>
        </div>
      </div>

      {/* Oversized brand */}
      <div className="mt-16 overflow-hidden">
        <p className="font-display text-[20vw] leading-none tracking-tighter font-light text-white/[0.03] text-center select-none">
          CUTTING EDGE
        </p>
      </div>
    </footer>
  );
}
